import { ReactNode } from 'react';
import { Status } from '@optimus-web/common';
import { FormMessage, MaxCharacterCount } from '../common';
import { Stack } from '../Stack';
import { FieldProps } from '.';

interface FieldFormMessagesProps {
    name: string;
    error?: ReactNode;
    helper?: ReactNode;
    disabled?: boolean;
    readOnly?: boolean;
    size?: FieldProps['size'];
    maxCharacterCount: number | undefined;
    inputLength: number;
}

export const FieldFormMessages = ({
    name,
    error,
    helper,
    disabled,
    readOnly,
    size,
    maxCharacterCount,
    inputLength,
}: FieldFormMessagesProps) => (
    <>
        <Stack
            spacing="50"
            distribution={(helper || error) && maxCharacterCount ? 'space-between' : undefined}
            alignment={!helper && !error && maxCharacterCount ? 'end' : undefined}
        >
            {helper ? (
                <FormMessage size={size} data-test-message-helper>
                    {helper}
                </FormMessage>
            ) : null}
            {error && !helper ? (
                <FormMessage status={Status.Error} id={`${name}-error`} data-test-message-error role="alert">
                    {error}
                </FormMessage>
            ) : null}
            {maxCharacterCount && !disabled && !readOnly ? (
                <MaxCharacterCount inputValueLength={inputLength} maxCharacterCount={maxCharacterCount} />
            ) : null}
        </Stack>
        {error && helper ? (
            <FormMessage status={Status.Error} id={`${name}-error`} data-test-message-error role="alert">
                {error}
            </FormMessage>
        ) : null}
    </>
);
